/// <reference path="../_references.ts"/>

module App.PriceGuide {
	import Department = App.Appointments.Department;
	import TermsConditions = App.WorkOrder.TermsConditions;

	export class ProductService {
		constructor(
			private $http: ng.IHttpService,
			public Constants: IConstants
		) {

		}

		getCollectsTax(orgId: number|'current'): ng.IHttpPromise<{collect: boolean}> {
			return this.$http.get(`${this.Constants.apiUrl}organization/${orgId}/salestax`, {
				params: {
					quiet: 1,
					show_collect: 1,
				},
			});
		}

		getTermsConditions(): ng.IHttpPromise<TermsConditions[]> {
			return this.$http.get(`${this.Constants.apiUrl}termsandconditions`, {
				params: {
					visible: 1,
				},
			});
		}

		getWarranties(): ng.IHttpPromise<Warranty[]> {
			return this.$http.get(`${this.Constants.apiUrl}warranty`);
		}

		getDepartments(): ng.IHttpPromise<Department[]> {
			return this.$http.get(`${this.Constants.apiUrl}department`);
		}

		getCategories(departmentId: number): ng.IHttpPromise<ServiceCategory[]> {
			return this.$http.get(`${this.Constants.apiUrl}servicecategory?department=${departmentId}`);
		}

		getPackages(serviceRequestId: number, params?: any): ng.IHttpPromise<Package[]> {
			return this.$http.get(`${this.Constants.apiUrl}servicerequest/${serviceRequestId}/package`, {
				params: params || {}
			});
		}

		getPackage(serviceRequestId: number, packageId: number): ng.IHttpPromise<Package> {
			return this.$http.get(`${this.Constants.apiUrl}servicerequest/${serviceRequestId}/package/${packageId}`);
		}

		duplicatePackage(serviceRequestId: number, packageId: number): ng.IHttpPromise<Package> {
			return this.$http.post(`${this.Constants.apiUrl}servicerequest/${serviceRequestId}/package/${packageId}/duplicate`, {});
		}

		getProductList(params: SearchParams): ng.IHttpPromise<Product[]> {
			return this.$http.get(`${this.Constants.apiUrl}service`, {
				params: params || {}
			});
		}

		getPackagePresetNames(): ng.IHttpPromise<PackagePresetName[]> {
			return this.$http.get(`${this.Constants.apiUrl}packagepresetname`);
		}

		getPackagePresetNotes(): ng.IHttpPromise<PackagePresetNote[]> {
			return this.$http.get(`${this.Constants.apiUrl}packagepresetnote`);
		}

		createCustomProduct(product: Product): ng.IHttpPromise<Product> {
			return this.$http.post(`${this.Constants.apiUrl}service`, product);
		}

		createPackage(serviceRequestId: number, newPackage: Package): ng.IHttpPromise<Product[]> {
			return this.$http.post(`${this.Constants.apiUrl}servicerequest/${serviceRequestId}/package`, newPackage);
		}

		updatePackage(serviceRequestId: number, pkg: any, params?: any):  ng.IHttpPromise<Package> {
			return this.$http.put(`${this.Constants.apiUrl}servicerequest/${serviceRequestId}/package/${pkg.id}`, pkg, {
				params: params || {}
			});
		}

		updateServiceRequest(serviceRequestId: number, data: any, options?: ng.IRequestShortcutConfig):  ng.IHttpPromise<Package> {
			return this.$http.put(`${this.Constants.apiUrl}servicerequest/${serviceRequestId}`, data, options);
		}

		deletePackageService(serviceRequestId: number, packageId: number, servicePackageId: number) {
			return this.$http.delete(`${this.Constants.apiUrl}servicerequest/${serviceRequestId}/package/${packageId}/service/${servicePackageId}`);
		}

		createPackageService(serviceRequestId: number, packageId: number, service: ReturnedProduct) {
			return this.$http.post(`${this.Constants.apiUrl}servicerequest/${serviceRequestId}/package/${packageId}/service`, service);
		}

		updatePackageService(serviceRequestId: number, packageId: number, service: Product) {
			return this.$http.put(`${this.Constants.apiUrl}servicerequest/${serviceRequestId}/package/${packageId}/service/${service.id}`, service);
		}

		deletePackage(serviceRequestId: number, pkgId: number): ng.IHttpPromise<Package> {
			return this.$http.delete(`${this.Constants.apiUrl}servicerequest/${serviceRequestId}/package/${pkgId}`);
		}

		restorePackage(serviceRequestId: number, pkg: any, params?: any): ng.IHttpPromise<Package> {
			return this.$http.put(`${this.Constants.apiUrl}servicerequest/${serviceRequestId}/package/${pkg.id}/restore`, pkg, {
				params: params || {},
			});
		}

		recommendPackage(serviceRequestId: number, pkgId: number, data: any): ng.IHttpPromise<Package> {
			return this.$http.post(`${this.Constants.apiUrl}servicerequest/${serviceRequestId}/package/${pkgId}/recommend`, data || {});
		}

		public static Factory() {
			let instance = ($http: ng.IHttpService, Constants: IConstants) => {
				return new ProductService($http, Constants);
			};

			instance.$inject = ['$http', 'Constants'];

			return instance;
		}
	}
}